/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import {
    object, string, arrayOf, shape,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import triggerPopChatEvent from '../../MultiBrandChatController/AigoChatWidgetWrapperV2/popOpenChat';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const CallOrderDetail = ({
    classes, tips: {
        tip_link_color, tipe_title, tip_list,
    },
    operatingSystem, currentBrand, featureFlags, customerData, chatLinkStyle,
}) => {
    const dispatch = useDispatch();
    return (
        <Grid container className={classes.container}>
            <Grid item className={classes.callInfo}>
                <div className={`${classes.orderByPhone}`}>
                    <h3 style={{ marginBottom: '15px' }}> If you need assistance placing your international order, please
                        <span
                            onClick={() => {
                                dispatch(trackEvent({
                                    eventCategory: 'Chat',
                                    eventAction: 'Click',
                                    eventLabel: 'International Assistance',
                                }));
                                triggerPopChatEvent({}, operatingSystem, currentBrand, featureFlags, customerData);
                            }}
                            onKeyDown={() => { }}
                            role="button"
                            tabIndex="0"
                            alt="chat"
                            style={chatLinkStyle}
                        >chat
                        </span>with us!
                    </h3>
                    <h3 className={`${classes.orderByCallTitle} ${classes.callFlexBasis}`}>{tipe_title}:</h3>
                    <div className={`${classes.callNumberDetail} ${classes.callFlexBasis}`}>
                        <ul className={`${classes.callFlexBasis} ${classes.callByTitle}`}>
                            {tip_list.map((list, i)  => (
                                <li key={['_', i].join('')}>
                                    <Link style={{ color: `${tip_link_color}` }} className={classes.headingLink} to={list.url}> {list.tip_name}</Link>
                                </li>

                            ))}
                        </ul>
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};

CallOrderDetail.propTypes = {
    classes: object.isRequired,
    tips: shape({
        tip_link_color: string.isRequired,
        tipe_title: string.isRequired,
        tip_list: arrayOf(
            shape({
                url: string.isRequired,
                tip_name: string.isRequired,
            }),
        ),
    }).isRequired,
    currentBrand: string.isRequired,
    featureFlags: object.isRequired,
    operatingSystem: string.isRequired,
    customerData: object.isRequired,
    chatLinkStyle: object.isRequired,
};

export default CallOrderDetail;
